import React, { useState } from 'react';
import {
  IonPage, IonHeader, IonToolbar, IonTitle, IonContent,
  IonButton, IonText, IonSpinner,
} from '@ionic/react';
import { useHistory } from 'react-router-dom';
import { authService } from '../services/authService';
import { useAuthStore } from '../store/authStore';

const Login: React.FC = () => {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [rememberMe, setRememberMe] = useState(
    localStorage.getItem('rememberMe') === 'true'
  );
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);
  const history = useHistory();
  const setAuth = useAuthStore((s) => s.setAuth);

  const handleLogin = async () => {
    if (!email || !password) {
      setError('Please enter email and password');
      return;
    }
    setError('');
    setLoading(true);
    try {
      const { access_token } = await authService.login({ email, password });
      if (rememberMe) {
        localStorage.setItem('token', access_token);
        localStorage.setItem('rememberMe', 'true');
        sessionStorage.removeItem('token');
      } else {
        sessionStorage.setItem('token', access_token);
        localStorage.removeItem('token');
        localStorage.removeItem('rememberMe');
      }
      const user = await authService.getMe();
      setAuth(user, access_token);
      history.push('/dashboard');
    } catch (err: any) {
      console.error('Login error:', err.response?.status, err.response?.data);
      setError(err.response?.data?.detail || 'Login failed');
    } finally {
      setLoading(false);
    }
  };

  return (
    <IonPage>
      <IonHeader>
        <IonToolbar color="primary">
          <IonTitle>Stashbinder - Login</IonTitle>
        </IonToolbar>
      </IonHeader>
      <IonContent className="ion-padding" scrollY={false}>
        <div style={{ maxWidth: 400, margin: '0 auto', display: 'flex', flexDirection: 'column', height: '100%' }}>
          {/* Image aligned to top */}
          <div style={{ textAlign: 'center', paddingTop: 16 }}>
            <img
              src="assets/icon/StashBinder.png"
              alt="Stashbinder"
              style={{ width: 300, height: 300, objectFit: 'contain' }}
            />
          </div>

          {/* Spacer pushes controls to the bottom */}
          <div style={{ flex: 1 }} />

          {/* Controls aligned from bottom up */}
          <div style={{ paddingBottom: 24 }}>
            <h2>Welcome Back</h2>
            <div style={{ marginBottom: 12 }}>
              <label style={{ display: 'block', marginBottom: 4, fontSize: 14, color: 'var(--ion-color-medium)' }}>Email</label>
              <input
                type="email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                style={{ width: '100%', padding: '10px 12px', fontSize: 16, border: '1px solid var(--ion-color-medium)', borderRadius: 8, background: 'var(--ion-item-background, #fff)', color: 'var(--ion-text-color)', boxSizing: 'border-box' }}
              />
            </div>
            <div style={{ marginBottom: 12 }}>
              <label style={{ display: 'block', marginBottom: 4, fontSize: 14, color: 'var(--ion-color-medium)' }}>Password</label>
              <input
                type="password"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                style={{ width: '100%', padding: '10px 12px', fontSize: 16, border: '1px solid var(--ion-color-medium)', borderRadius: 8, background: 'var(--ion-item-background, #fff)', color: 'var(--ion-text-color)', boxSizing: 'border-box' }}
              />
            </div>
            <div style={{ display: 'flex', alignItems: 'center', marginBottom: 12 }}>
              <input
                type="checkbox"
                id="rememberMe"
                checked={rememberMe}
                onChange={(e) => setRememberMe(e.target.checked)}
                style={{ marginRight: 8, width: 18, height: 18 }}
              />
              <label htmlFor="rememberMe" style={{ fontSize: 14, color: 'var(--ion-color-medium)', cursor: 'pointer' }}>
                Remember me
              </label>
            </div>
            {error && <IonText color="danger"><p>{error}</p></IonText>}
            <IonButton expand="block" onClick={handleLogin} disabled={loading} style={{ marginTop: 16 }}>
              {loading ? <IonSpinner name="crescent" /> : 'Login'}
            </IonButton>
            <IonButton expand="block" fill="clear" routerLink="/register">
              Don&apos;t have an account? Register
            </IonButton>
          </div>
        </div>
      </IonContent>
    </IonPage>
  );
};

export default Login;
